import {useContext} from 'react';
import {view} from '@sail/ui/deprecated';

import {useIntl} from 'react-intl';
import {AvailabilityNotice} from '@stripe-internal/conversations-ui';
import {Channel, ChannelType} from './Channel';
import {getDisplayChannels} from './getDisplayChannels';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {EligibleChannelsEndpointResponseChannel} from '../../../generated/types';
import {Topic} from '../TopicSelector';

export type Props = {
  eligibleChannels?: EligibleChannelsEndpointResponseChannel[] | null;
  noticeMessage?: string;
  selectedTopic?: Topic;
  onChannelSelected: (channel: ChannelType) => void;
};

export function ChannelSelector({
  eligibleChannels,
  noticeMessage,
  selectedTopic,
  onChannelSelected,
}: Props) {
  const {locale} = useIntl();
  const {supportPlan, disableTopicSelector} = useContext(ConfigContext);

  const displayChannels = getDisplayChannels({
    channels: eligibleChannels,
    isPremiumSupport: supportPlan !== undefined,
    selectedTopic,
    disableTopicSelector,
    locale,
    showUnavailableChannels: true,
  });

  return (
    <view.div className="ChannelList" data-testid="ChannelList">
      {noticeMessage && <AvailabilityNotice notice={noticeMessage} />}
      {displayChannels.map((channel: ChannelType) => (
        <Channel
          key={channel.type}
          channel={channel}
          onClick={() => onChannelSelected(channel)}
        />
      ))}
    </view.div>
  );
}
